(function () {
  // ─── GCM: initialize dataLayer and gtag ───────────────────────────────────
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };

  gtag("set", "ads_data_redaction", true);
  gtag("set", "url_passthrough", true);

  // Default for all non-CA regions: granted
  gtag("consent", "default", {
    ad_storage:             "granted",
    ad_user_data:           "granted",
    ad_personalization:     "granted",
    analytics_storage:      "granted",
    functionality_storage:  "granted",
    personalization_storage:"granted",
    security_storage:       "granted"
  });

  // California override: denied until explicit banner action
  // wait_for_update matches observed Shopify API resolution time (~2500ms)
  gtag("consent", "default", {
    ad_storage:             "denied",
    ad_user_data:           "denied",
    ad_personalization:     "denied",
    analytics_storage:      "denied",
    functionality_storage:  "denied",
    personalization_storage:"denied",
    security_storage:       "granted",
    region:          ["US-CA"],
    wait_for_update: 3000
  });

  // ─── Synchronous early read for returning visitors ────────────────────────
  // Shopify stores prior consent in _tracking_consent cookie.
  // Read it now, synchronously, before GTM fires any tags.
  // This eliminates the ~2500ms modeling window for returning visitors.
  (function () {
    try {
      var match = document.cookie.match(/(?:^|;\s*)_tracking_consent=([^;]+)/);
      if (!match) return;
      var stored = JSON.parse(decodeURIComponent(match[1]));
      var con = stored && stored.con;
      if (!con) return;

      // m=marketing, a=analytics, p=preferences
      var marketing  = con.m === "1" || con.m === "yes";
      var analytics  = con.a === "1" || con.a === "yes";
      var functional = con.p === "1" || con.p === "yes";

      gtag("consent", "update", {
        ad_storage:             marketing  ? "granted" : "denied",
        ad_user_data:           marketing  ? "granted" : "denied",
        ad_personalization:     marketing  ? "granted" : "denied",
        analytics_storage:      analytics  ? "granted" : "denied",
        functionality_storage:  functional ? "granted" : "denied",
        personalization_storage:functional ? "granted" : "denied",
        security_storage:       "granted"
      });
    } catch (e) {
      // cookie unreadable — fall through to loadFeatures path below
    }
  })();

  // ─── Async path: Shopify customerPrivacy API ──────────────────────────────
  // Handles: first-time visitors (no cookie), and live banner interactions.
  var features = [{ name: "consent-tracking-api", version: "0.1" }];

  function isGranted(v) { return v === true || v === "yes"; }

  function applyConsent(consent) {
    if (!consent) return;

    // Empty strings = no decision made yet. Let GCM defaults handle it.
    // Only act on an explicit "yes"/"no" (stored cookie) or boolean (banner event).
    var hasExplicitChoice =
      consent.marketing === "yes" || consent.marketing === "no" ||
      typeof consent.marketingAllowed === "boolean";
    if (!hasExplicitChoice) return;

    var marketing  = isGranted(consent.marketing)   || consent.marketingAllowed   === true;
    var analytics  = isGranted(consent.analytics)   || consent.analyticsAllowed   === true;
    var functional = isGranted(consent.preferences) || consent.preferencesAllowed === true;

    gtag("consent", "update", {
      ad_storage:              marketing  ? "granted" : "denied",
      ad_user_data:            marketing  ? "granted" : "denied",
      ad_personalization:      marketing  ? "granted" : "denied",
      analytics_storage:       analytics  ? "granted" : "denied",
      functionality_storage:   functional ? "granted" : "denied",
      personalization_storage: functional ? "granted" : "denied",
      security_storage:        "granted"
    });
  }

  function initConsent() {
    if (!window.Shopify || !window.Shopify.loadFeatures) return;
    window.Shopify.loadFeatures(features, function (err) {
      if (err) { console.error("Avada GCM: consent-tracking-api failed", err); return; }
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) return;
      // Apply stored state for this session
      applyConsent(cp.currentVisitorConsent && cp.currentVisitorConsent());
      // Apply on every future banner interaction
      document.addEventListener("visitorConsentCollected", function (e) {
        applyConsent((e && e.detail) || {});
      });
    });
  }

  // Guard against script executing before Shopify's JS is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initConsent);
  } else {
    initConsent();
  }
})();